var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "park"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "cls-1",
    d: "M5,29v3H3V29Zm14,0v3H17V29ZM25,0a7,7,0,0,1,1,13.92h0v3.17l1.79-1.8,1.42,1.42L26,19.91V32H24V13.92A7,7,0,0,1,25,0ZM22,26v2H0V26Zm0-7v2H19v1h3v2H19v1H17V24H5v1H3V24H0V22H3V21H0V19Zm-5,2H5v1H17ZM25,2a5,5,0,1,0,5,5A5,5,0,0,0,25,2ZM12,4V6A4,4,0,0,0,8.8,7.6h0L8.5,8h-1l-.3-.4A4,4,0,0,0,4,6H4V4A6,6,0,0,1,8,5.53,6,6,0,0,1,12,4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPark);
export default __webpack_public_path__ + "static/media/park.6f48594a.svg";
export { ForwardRef as ReactComponent };